export const imgUrl = 'https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/';

export const ResturantMenuUrl =
  'https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9351929&lng=77.62448069999999&restaurantId=';

export const filterArrList = ['Select Filter', 'Delivery Time', 'Rating', 'Low To High', 'High To Low'];

export const ResturantDetailsUrl =
  // "https://www.swiggy.com/dapi/restaurants/list/v5?lat=30.7046486&lng=76.71787259999999&offset=1";
  `https://www.swiggy.com/dapi/restaurants/list/v5?lat=30.7258091&lng=76.6715462&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING`;

export const NavbarLinksArr = [
  { name: 'Home', url: '/home' },
  { name: 'About', url: '/about' },
  { name: 'Contact', url: '/contact' },
  { name: 'Cart', url: '/Cart' },
];

export const GitRepoPath = 'https://github.com/mehraTushar/HungryHub';

export const EmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
